<template>
  <div class="maintenance-container">
    <div class="page-title" id="page_title">{{ $sakura.locale.factory.title }}</div>
    <div class="page-introduce mb20 mt5" id="page_intro">{{ $sakura.locale.factory.introduce }}</div>

    <el-row :gutter="20" class="mb20">
      <el-col :span="12">
        <el-card class="box-card" shadow="never">
          <template #header>
            <div class="flex-layout" style="align-items: center;">
              <div class="flex-item left f20" id="factory_card4_title">{{ $sakura.locale.maintenance.card4.title }}</div>
            </div>
          </template>
          <div class="card-body">
            <div class="body-introduce mb20" id="factory_card4_introduce">{{ $sakura.locale.maintenance.card4.introduce }}</div>
            <div class="mb20">
              <el-button @click.stop="saveHandler" id="factory_save_button">
                {{ $sakura.locale.maintenance.card4.factory_default }}
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card" shadow="never">
          <template #header>
            <div class="flex-layout" style="align-items: center;">
              <div class="flex-item left f20" id="factory_card5_title">{{ $sakura.locale.maintenance.card5.title }}</div>
            </div>
          </template>
          <div class="card-body">
            <div class="body-introduce mb20" id="factory_card5_introduce">{{ $sakura.locale.maintenance.card5.introduce }}</div>
            <div class="mb20">
              <el-button @click.stop="eraseHandler" id="factory_card5_button">
                {{ $sakura.locale.maintenance.card5.btn }}
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue'
import { ElMessageBox } from 'element-plus';

const $sakura = getCurrentInstance()?.appContext.config.globalProperties.$sakura;
const $api = getCurrentInstance()?.appContext.config.globalProperties.$api

const confirmHandler = (title, msg, confirmButtonText, cancelButtonText) => {
  return new Promise(resolve => {
    ElMessageBox.confirm(msg, title, {
      confirmButtonText,
      cancelButtonText,
      closeOnClickModal: false,
      closeOnPressEscape: false
    }).then(() => {
      resolve(true)
    }).catch(() => {
      resolve(false)
    })
  })
}

const saveHandler = () => {
  const { title, message, confirmButtonText, cancelButtonText } = $sakura.locale.maintenance.configuration_confirm
  confirmHandler(title, message, confirmButtonText, cancelButtonText).then((status) => {
    if (status) {
      $api.common.saveConfiguration({ 'running-config': true }).then(data => {
        $sakura.sakuraMessage(data.resp.respCode)
      })
    }
  })
}

const eraseHandler = () => {
  const { title, messageErase, confirmButtonText, cancelButtonText } = $sakura.locale.maintenance.configuration_confirm;
  confirmHandler(title, messageErase, confirmButtonText, cancelButtonText).then((status) => {
    if (status) {
      $api.common.eraseConfiguration({}).then(data => {
        $sakura.sakuraMessage(data.resp.respCode)
      })
    }
  })
}
</script>
<style lang="scss" scoped>
.maintenance-container {
    overflow-x: hidden;

    .body-title {
        color: #1c1d1e;
    }

}
</style>